// Services
import { AbstractDataClient } from '~/misc/services/data-client';
import { ExternalOfficeModel } from '~/modules/manager/models/external-office';

export class ManagerExternalOfficeDataClient extends AbstractDataClient<ExternalOfficeModel> {
  constructor() {
    super(new ExternalOfficeModel());
  }
}
